<div class="card w-100">
  <div class="card-header p-0 pl-3 pr-2">
    <!-- Match button signatures: wrapping title and chips on the left, fixed control on the right. -->
    <div class="row pb-0 flex-row flex-nowrap justify-content-between">
      <div
        class="approval-header-content p-3 d-flex flex-column align-items-start"
      >
        <h6 [innerHTML]="labelHtml | placeholderHighlight: editor"></h6>
        <div class="approval-roles d-flex align-items-center">
          <role-chips
            *ngIf="roleCodes || (userNames && !value)"
            [roleCodes]="roleCodes"
            [userNames]="userNames"
            [alignLeft]="true"
          ></role-chips>
        </div>
      </div>

      <div
        class="approval-actions p-1 pr-3 d-flex justify-content-end align-items-center"
      >
        <mat-checkbox-with-roles
          [checked]="value"
          class="checkbox"
          [disabled]="disabled ?? false"
          (change)="checkboxChanged($event)"
          color="primary"
          [user]="user"
          [date]="date"
          [warning]=""
        >
        </mat-checkbox-with-roles>
      </div>
    </div>
  </div>
  <div class="card-body d-flex flex-column justify-content-center py-2">
    <div class="row">
      <div class="col-3 nowrap">By:</div>
      <div class="col-9">
        <span class="name" *ngIf="value">{{ user?.name }}</span>
      </div>
    </div>
    <div class="row">
      <div class="col-3">
        <small class="nowrap">Date:</small>
      </div>
      <div class="col-9">
        <span class="date small" *ngIf="value">{{
          date | date: "medium"
        }}</span>
      </div>
    </div>
    <!-- Tester tool (non-production, System Administrators only): signs this as the appropriate
         user. Independent of the checkbox's disabled state. -->
    <div class="d-flex justify-content-end mt-2" *ngIf="showTestApprove">
      <button
        mat-stroked-button
        color="warn"
        type="button"
        (click)="testApprove.emit()"
        matTooltip="Tester tool (non-production): signs this as the appropriate user, so you don't have to log in as that user."
        [matTooltipPosition]="'right'"
      >
        <mat-icon>auto_fix_high</mat-icon> Approve
      </button>
    </div>
  </div>
</div>
